<template>
  <vx-card
    class="campaigns-table"
    :noShadow="true"
    :title="$t('')"
  >
    <template v-slot:actions>
      <div class="system-logs-title flex">
        <h4 class="mt-6">Activity Log</h4>
      </div>

      <div class="system-logs-table-row vx-row">
        <div class="vx-col w-full">
        <!-- desktop version -->
        <ul class="system-logs-desktop-version float-right list-none text-right mt-6">
          <li class="inline-block float-right">
            <vs-button class="shadow-none speakol-table-filter-button" @click="applyFilters">
              {{ $t('Filter') }}
            </vs-button>
          </li>

          <li class="inline-block float-right mr-3">
            <speakol-date-range-picker class="campaigns-datePicker" v-model="agFilters.dateRange" :placeholder="$t('Filter by date')"></speakol-date-range-picker>
          </li>

          <li class="inline-block float-right mr-3">
            <div class="search-parent">
              <vs-icon class="domains-targeting-search-icon speakol-search" icon-pack="speakol" round></vs-icon>
              <input placeholder="Search by user ..." class="domains-targeting-table-input" type="text" v-model="agFilters.query" @keyup.enter="applyFilters()" />
            </div>
          </li>
        </ul>
        <!-- desktop version -->

          <!-- mobile version -->
          <ul class="system-logs-mobile-version list-none text-right mb-10">
            <li class="inline-block float-right w-full mb-4">
              <vs-input class="w-full speakol-table-input" icon-pack="speakol" icon="speakol-search" placeholder="Search ..." v-model="agFilters.keyword"/>
            </li>

            <li class="speakol-table-filter-button-mobile-version-parent inline-block float-right mb-4">
              <vs-button class="shadow-none speakol-table-filter-button speakol-table-filter-button-mobile-version" @click="applyFilters()">
                {{ $t('Filter') }}
              </vs-button>
            </li>
          </ul>
          <!-- mobile version -->
        </div>
      </div>
    </template>
    <div class="system-logs-table">
      <a-g-speakol-table ref="logsTable" :filters="agFilters" :columns="agColumns" :options="agOptions"></a-g-speakol-table>
    </div>
  </vx-card>
</template>

<script>
import LogsDataSource from '@/datasources/LogsDataSource'

import AGSpeakolTable from '@/components/AGSpeakolTable'

import CompareValues from './_table_partials/CompareValues.vue'

import SpeakolMainButton from '@/components/speakol-template/SpeakolMainButton.vue'

export default {
  components: {
    SpeakolMainButton,
    AGSpeakolTable,
    CompareValues
  },
  data () {
    return {
      agOptions: this.getTableOptions(),
      agColumns: this.getTableColumns(),
      agFilters: {
        query: null,
        dateRange: {
          startDate: new Date('January 1, 2016'),
          endDate: new Date()
        }
      }
    }
  },
  methods: {
    getTableOptions () {
      return {
        dataSource: LogsDataSource
      }
    },
    getTableColumns () {
      return [
        {
          headerName: 'Date',
          field: 'created_at',
          sortable: true
        },
        {
          headerName: 'User',
          field: 'user.id',
          minWidth: 100,
          valueGetter (params) {
            if (params.data) {
              return (params.data.user || {}).name || 'N/A'
            }
            return 'N/A'
          }
        },
        {
          headerName: 'Actions',
          field: 'action',
          minWidth: 50,
          valueGetter (params) {
            const log = params.data

            if (!log) {
              return 'N/A'
            }

            const entity = log.auditable_type.split('\\')

            return `${entity[entity.length - 1]} "${log.auditable_entity.name}" ${log.event}`
          }
        }
      ]
    },
    applyFilters () {
      this.$refs['logsTable'].applyFilters()
    }
  }
}
</script>


<style lang="scss">

.system-logs-title {
  position: absolute;
  left: 20px;
  top: 25px;
}

.system-logs-mobile-version {
  display: none;
}

.system-logs-table-row {
  margin-bottom: 30px;
}

.remove-selected-domain {
  position: relative;
  top: 2px;
  font-size: 16px !important;
}

/deep/ .vs-switch {
  margin-top: 0 !important;
}

.system-logs-table {
  .ag-cell-value {
    text-overflow: ellipsis;
    overflow: hidden;
    // width: 500px;
    white-space: nowrap;
  }

  .ag-cell-wrapper {
    display: contents !important;
  }

  .ag-input-field-input {
    cursor: pointer;
  }

  .vs-switch-active {
    background: #0092d7 !important;
  }
}

.search-parent {
  position: relative;

  .domains-targeting-table-input {
    width: 280px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    text-indent: 30px;
    height: 40px;
  }

  .domains-targeting-table-input::placeholder {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  .domains-targeting-search-icon {
    position: absolute;
    z-index: 1;
    top: 9px;
    left: 6px;
    color: rgba(0, 0, 0, 0.25);
  }
}

@media (max-width: 768px) {
  .system-logs-mobile-version {
    display: block;
  }

  .system-logs-desktop-version {
    display: none !important;
  }

  .speakol-table-filter-button-mobile-version-parent {
    width: 100% !important;

    button {
      width: 100% !important;
    }
  }
}
</style>
